import type { Sprite } from 'pixi.js';
import type { RecyclablePiece } from './RecyclableCullingView';
import type { AllProps } from '../../../libs/propsMixin/props';
import { GAME_OBJECT_POOL } from '../../../game/GameConstants';

export class RecyclableSpritePiece implements RecyclablePiece {
  private sprite: Sprite | null = null;

  constructor(private readonly props: AllProps) {}

  public activate(): void {
    this.sprite = GAME_OBJECT_POOL.getSprite().props({
      ...this.props,
    });

    if (this.sprite.destroyed) {
      console.error('destroyed sprite from pool');
    }
  }

  public deactivate(): void {
    if (!this.sprite) return;
    GAME_OBJECT_POOL.addSprite(this.sprite);
    this.sprite = null;
  }

  public destroy(): void {
    this.deactivate();
  }
}
